import { Dialog } from "@mui/material"
import { useState } from "react"
import WhatsAppChoose from "./WhatsAppChoose"

export default function WhatsAppLink({
    whatsAppPhone,
    whatsAppText,
    children
}) {
    const [open, setOpen] = useState(false)
    const openWhatsAppHandler = () => {
        let whatsapp = localStorage.getItem('whatsapp')
        if (whatsapp && whatsAppPhone) {
            let url = ``
            if (whatsapp === "WEB") {
                url = `https://web.whatsapp.com/send?phone=${whatsAppPhone}`
            } else if (whatsapp === "DESKTOP") {
                url = `whatsapp://send?phone=${whatsAppPhone}`
            }
            if (whatsAppText && whatsapp === "DESKTOP") {
                url += `&text=${whatsAppText}`
            } else if (whatsAppText && whatsapp === "WEB") {
                url += `&text=%20${whatsAppText}`
            }
            window.open(url)
        } else {
            dialogToggleHandler(true)
        }
    }

    const dialogToggleHandler = (value) => {
        setOpen(value)
    }

    return (
        <>
            <span style={{ cursor: 'pointer' }} onClick={openWhatsAppHandler}>
                {children}
            </span>
            <Dialog
                onClose={() => dialogToggleHandler(false)}
                open={open}
                fullWidth={true}
            >
                <WhatsAppChoose
                    whatsAppPhone={whatsAppPhone}
                    whatsAppText={whatsAppText}
                    dialogToggleHandler={dialogToggleHandler}
                />
            </Dialog>
        </>
    )

}